<mat-card>
  <mat-card-header>
    <mat-card-title>
      <div class="title">
        {{ 'AI_ASSISTANT.TESTING.RUN_TABLE.TITLE' | translate }}
        <button color="primary" (click)="refresh()" mat-icon-button><mat-icon>refresh</mat-icon></button>
      </div>
    </mat-card-title>
    <div class="header-actions">
      @if (showSuccessEvalFilters) {
        <mat-slide-toggle
          [checked]="onlySuccessEvaluations"
          (change)="toggleOnlySuccessEvaluations($event.checked)"
        >
          {{ 'AI_ASSISTANT.TESTING.RUN_TABLE.FILTER_ONLY_SUCCESS_EVALUATIONS' | translate }}
        </mat-slide-toggle>
      }

      @if (enableComparison) {
        <button [disabled]="!canCompare" mat-flat-button color="accent" (click)="onCompareClick()">
          <mat-icon>compare_arrows</mat-icon>
          {{ 'AI_ASSISTANT.TESTING.RUN_TABLE.COMPARE_SELECTED' | translate }}
        </button>
      }
    </div>
  </mat-card-header>
  @if (showSuccessEvalFilters) {
  <div class="source-id-search">
    @if (hasVoice) {
      <glxy-form-field [showLabel]="false" [bottomSpacing]="false" class="source-type">
        <glxy-label>{{ 'AI_ASSISTANT.TESTING.RUN_TABLE.SOURCE_FILTER_KIND' | translate }}</glxy-label>
        <mat-select [value]="sourceFilterType" (selectionChange)="onSourceTypeChange($event.value)">
          <mat-option value="conversationId">
            {{ 'AI_ASSISTANT.TESTING.RUN_TABLE.SOURCE_TYPE_CONVERSATION' | translate }}
          </mat-option>
          <mat-option value="callRecordId">
            {{ 'AI_ASSISTANT.TESTING.RUN_TABLE.SOURCE_TYPE_CALL' | translate }}
          </mat-option>
        </mat-select>
      </glxy-form-field>
    }

    <glxy-form-field
      [showLabel]="false"
      [bottomSpacing]="false"
      class="source-id-input"
      [suffixIcon]="sourceIdControl.value ? '' : 'search'"
    >
      <glxy-label>{{ 'AI_ASSISTANT.TESTING.RUN_TABLE.SOURCE_ID_LABEL' | translate }}</glxy-label>
      <input
        matInput
        type="text"
        [formControl]="sourceIdControl"
        [placeholder]="
          (sourceFilterType === 'callRecordId'
            ? 'AI_ASSISTANT.TESTING.RUN_TABLE.SOURCE_ID_PLACEHOLDER_CALL'
            : 'AI_ASSISTANT.TESTING.RUN_TABLE.SOURCE_ID_PLACEHOLDER_CONVERSATION'
          ) | translate
        "
      />
      @if (sourceIdControl.value) {
        <button matSuffix mat-icon-button (click)="clearSourceFilter()" aria-label="Clear">
          <mat-icon>close</mat-icon>
        </button>
      }
    </glxy-form-field>
  </div>
  }
  <mat-card-content>
    @if (enableComparison) {
      <div class="selection-hint">
        <mat-icon>info</mat-icon>
        <span>{{ 'AI_ASSISTANT.TESTING.RUN_TABLE.SELECT_COMPARE' | translate: { count: selectedRuns().size } }}</span>
      </div>
    }
    <glxy-table-container
      class="simple-table"
      [dataSource]="dataSource"
      [columns]="columns"
      [pageSizeOptions]="[10, 20, 30]"
      [pageSize]="10"
      [border]="false"
      [fullWidth]="false"
    >
      <glxy-table-content-header
        [showFilters]="false"
        [showFiltersButton]="false"
        [showSort]="false"
        [showSearch]="false"
        [showColumnArrange]="false"
      ></glxy-table-content-header>
      <table mat-table matSort (matSortChange)="sortData($event)">
        <tr mat-header-row *matHeaderRowDef="[]"></tr>

        @if (enableComparison) {
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox
                [checked]="isSelected(row)"
                (click)="toggleSelection(row, $event)"
              ></mat-checkbox>
            </td>
          </ng-container>
        }

        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>{{ 'AI_ASSISTANT.TESTING.RUN_TABLE.NAME' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            <a (click)="navigateToTestRun(element)" class="run-link">{{ getRunName(element) }}</a>
          </td>
        </ng-container>

        <ng-container matColumnDef="created">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            {{ 'AI_ASSISTANT.TESTING.RUN_TABLE.DATE' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.created | date: 'medium' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="trigger">
          <th mat-header-cell *matHeaderCellDef>{{ 'AI_ASSISTANT.TESTING.RUN_TABLE.TRIGGER' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            @if (isScheduledRun(element)) {
              <glxy-badge color="blue-solid" size="small">
                {{ 'AI_ASSISTANT.TESTING.RUN_TABLE.TRIGGER_SCHEDULED' | translate }}
              </glxy-badge>
            } @else {
              {{ 'AI_ASSISTANT.TESTING.RUN_TABLE.TRIGGER_MANUAL' | translate }}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>{{ 'AI_ASSISTANT.TESTING.RUN_TABLE.STATUS' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            @if (statusMap.get(element.status); as status) {
              <div class="status" [ngClass]="status.class">
                <mat-icon>{{ status.icon }}</mat-icon
                >{{ status.name | translate }}
              </div>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="passed">
          <th mat-header-cell *matHeaderCellDef>{{ 'AI_ASSISTANT.TESTING.RUN_TABLE.PASS_RATE' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            {{ getPassedCount(element) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="iterations">
          <th mat-header-cell *matHeaderCellDef>{{ 'AI_ASSISTANT.TESTING.RUN_TABLE.ITERATIONS' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            {{ getIterations(element) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="version">
          <th mat-header-cell *matHeaderCellDef>{{ 'AI_ASSISTANT.TESTING.RUN_TABLE.VERSION' | translate }}</th>
          <td mat-cell *matCellDef="let element">
            {{ getAssistantVersion(element) }}
          </td>
        </ng-container>

        <tr mat-row *matRowDef="let row; columns: []"></tr>
      </table>
    </glxy-table-container>
  </mat-card-content>
</mat-card>
